import React, { useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Card, Button, Collapse, Row, Col } from 'react-bootstrap';

const projectContent = [
  {
    title: "Obiective cheie",
    content: [
      "Crearea a peste 300 de locuri de muncă prin dezvoltarea infrastructurii parcului și operarea facilităților.",
      "Revitalizarea turismului regional și stimularea economiei locale.",
      "Înființarea unei grădinițe moderne pentru sprijinirea familiilor tinere.",
      "Instalarea de atracții tematice (ex. roată panoramică) pentru experiențe unice.",
      "Promovarea unui oraș verde și durabil, cu spații verzi extinse."
    ]
  },
  {
    title: "Analiză economică și financiară",
    content: [
      "Investiție inițială estimată: 6.000.000 EUR.",
      "Venituri anuale estimate: 2.000.000 EUR din chirii, taxe de acces, evenimente și sponsorizări.",
      "ROI estimat: 33% anual, recuperarea investiției în aproximativ 3 ani."
    ]
  },
  {
    title: "Sustenabilitate și impact social",
    content: [
      "Reducerea emisiilor de CO₂ și îmbunătățirea calității aerului.",
      "Crearea unui spațiu incluziv pentru toate vârstele și promovarea educației ecologice.",
      "Stimularea antreprenoriatului local și creșterea veniturilor fiscale."
    ]
  },
  {
    title: "Etape de implementare",
    content: [
      "Planificare și proiectare: consultări publice, planuri, autorizații.",
      "Finanțare: fonduri europene, naționale și investiții private.",
      "Construcție și amenajare: dezvoltarea infrastructurii, plantarea arborilor, instalarea atracțiilor.",
      "Operare și întreținere: gestionarea zilnică, organizarea de evenimente, întreținerea facilităților."
    ]
  }
];

export default function ProjectDetails() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-100" style={{ maxWidth: 900, margin: "48px auto 0 auto" }}>
      <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="h4 fw-bold" style={{ color: "#143685" }}>
            Detalii proiect „Plămânul Verde al Orașului”
          </h2>
          <Button
            variant="light"
            onClick={() => setIsExpanded(v => !v)}
            className="border-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              boxShadow: "0 2px 8px #e7eaf1",
              background: "#fff",
              color: "#143685",
              width: 44,
              height: 44
            }}
            aria-label={isExpanded ? "Ascunde detalii" : "Afișează detalii"}
          >
            {isExpanded ? <LuChevronUp size={24} /> : <LuChevronDown size={24} />}
          </Button>
        </div>

        <Collapse in={isExpanded}>
          <div>
            <Row className="gy-4">
              {projectContent.map((section, idx) => (
                <Col xs={12} key={idx}>
                  <Card className="mb-3 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
                    <Card.Body>
                      <h3 className="h5 fw-semibold mb-3 pb-2" style={{ color: "#143685", borderBottom: "2px solid #FFC72C" }}>
                        {section.title}
                      </h3>
                      <ul className="mb-0 ps-0" style={{ listStyle: "none" }}>
                        {section.content.map((item, itemIdx) => (
                          <li key={itemIdx} className="d-flex align-items-start mb-2">
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                background: "#FFC72C",
                                borderRadius: "50%",
                                marginTop: 8,
                                marginRight: 12,
                                flexShrink: 0
                              }}
                            ></span>
                            <span style={{ color: "#000", lineHeight: 1.6 }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <Card className="mt-4 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
              <Card.Body>
                <h4 className="fw-semibold mb-3" style={{ color: "#143685" }}>
                  Indicatori de succes
                </h4>
                <Row>
                  <Col md={6}>
                    <ul className="mb-3 ps-3" style={{ color: "#000", fontSize: 15 }}>
                      <li>Număr de vizitatori anual: Peste 500.000</li>
                      <li>Locuri de muncă create: Peste 300</li>
                      <li>Suprafață verde nou creată: Minimum 20 hectare</li>
                      <li>Reducerea emisiilor de CO₂: Cu 10% în zona urbană</li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <p style={{ color: "#143685", fontWeight: 500 }}>
                      „Plămânul Verde al Orașului” va transforma orașul într-un model de sustenabilitate, inovație și bunăstare pentru toți locuitorii săi.
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Collapse>

        {!isExpanded && (
          <div className="mt-3 text-center">
            <span className="text-secondary" style={{ fontSize: 14 }}>
              Apăsați pentru a vedea detaliile complete
            </span>
          </div>
        )}
      </Card>
    </div>
  );
}
